import { getListOfWhatsAppAccounts } from "../types/whatsapp_account_list_types";

const initState = {
  data: [],
  Count: 0,
  loading: false,
  error: null,
  cellLoading: null,
};

export default function whatsAppAccountListReducer(state = initState, action = {}) {
 
  switch (action.type) {
    case getListOfWhatsAppAccounts.GET_LIST_OF_WHATSAPP_ACCOUNTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getListOfWhatsAppAccounts.GET_LIST_OF_WHATSAPP_ACCOUNTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case getListOfWhatsAppAccounts.GET_LIST_OF_WHATSAPP_ACCOUNTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

      

      case getListOfWhatsAppAccounts.GET_COUNT_OF_WHATSAPP_ACCOUNTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getListOfWhatsAppAccounts.GET_COUNT_OF_WHATSAPP_ACCOUNTS_SUCCESS:
      console.log("[GET_COUNT_OF_WHATSAPP_ACCOUNTS] ::", action.payload)
      return {
        ...state,
        loading: false,
        Count: action.payload.totalCount,
        error: null,
      };
    case getListOfWhatsAppAccounts.GET_COUNT_OF_WHATSAPP_ACCOUNTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      
    default:
      return state;
  }
}
